// Component Styles
const styles = theme => ({
  grow: {
    flexGrow: 1
  },

  toolbar: {
    borderBottom: `1px solid rgba(0, 0, 0, 0.12)`
  },

  search: {
    marginTop: 5,
    marginLeft: 20,
    minWidth: 300
  },
})

export default styles
